import { render, staticRenderFns } from "./MainParticipants.vue?vue&type=template&id=5dfba5db&scoped=true"
import script from "./MainParticipants.vue?vue&type=script&lang=js"
export * from "./MainParticipants.vue?vue&type=script&lang=js"
import style0 from "./MainParticipants.vue?vue&type=style&index=0&id=5dfba5db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfba5db",
  null
  
)

export default component.exports